<template>
  <div>
      <KitchenOrders></KitchenOrders>
  </div>
</template>

<script>
  import KitchenOrders from '@/components/kitchen/KitchenOrders'
  
  export default {
    components : {
      KitchenOrders
    }
  }
</script>


